import { buildInspectSnapshot } from '../../domain/entity/inspectSnapshot.js';

/**
 * createEntityInspectController — Top-left inspect panel for LMB-selected entities.
 * Presentation only; stats via domain buildInspectSnapshot.
 */
export function createEntityInspectController({ documentRef = globalThis.document } = {}) {
  let selected = null;
  const root = documentRef?.getElementById?.('entity-inspect-panel') || null;

  function el(id) {
    return documentRef?.getElementById?.(id) || null;
  }

  function setText(id, value) {
    const node = el(id);
    if (node) node.textContent = value;
  }

  function hide() {
    if (root) root.style.display = 'none';
  }

  function render() {
    const snap = buildInspectSnapshot(selected);
    if (!snap || !root) {
      hide();
      return;
    }
    root.style.display = 'block';
    root.className = `entity-inspect-panel team-${snap.team}`;
    setText('inspect-name', snap.name);
    setText('inspect-meta', `${snap.type} · ${snap.team}${snap.isDead ? ' · dead' : ''}`);
    setText('inspect-hp', `${Math.ceil(snap.hp)} / ${Math.ceil(snap.maxHp)}`);
    setText('inspect-mp', `${Math.ceil(snap.mp)} / ${Math.ceil(snap.maxMp)}`);
    setText('inspect-ad', String(Math.round(snap.ad)));
    setText('inspect-armor', String(Math.round(snap.armor)));
    setText('inspect-mr', String(Math.round(snap.mr)));
    setText('inspect-ms', String(Math.round(snap.ms)));
    setText('inspect-as', Number(snap.as).toFixed(2));
    setText('inspect-level', String(snap.level));
  }

  return {
    setEntity(entity) {
      selected = entity && !entity.isDead ? entity : null;
      render();
    },
    clear() {
      selected = null;
      hide();
    },
    sync() {
      if (!selected) return;
      if (selected.isDead) {
        selected = null;
        hide();
        return;
      }
      render();
    },
    getSelected() {
      return selected;
    }
  };
}
